import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const Container1200 = (props) => {

    return (
        <div style={{
            width: '100dvw',
            minHeight: '100dvh',
            display: 'flex'
        }} >
            <div style={{
                width: '100dvw',
                maxWidth: '1200px',
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }} >

                {props.children}
            </div>
        </div>
    )
}

const Containerfull = (props) => {

    return (
        <div style={{
            minHeight: '100dvh',
            width: '100dvw',
            display: 'flex'
        }} >
            <div style={{
                width: '100dvw',
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }} >

                {props.children}
            </div>
        </div>
    )
}

const HeaderMidImg = (props, { bgColor = '#146C94', subBgColor = '#AFD3E2', imgSrc = '' }) => {

    return (
        <div>
            <div style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                backgroundColor: bgColor,
                padding: '0.2em'
            }} >
                <img
                    style={{
                        height: '5em'
                    }}
                    alt=""
                    src={imgSrc} />
            </div>
            <div style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                backgroundColor: subBgColor,
                padding: '0.2em'
            }} >
                {props.children}
            </div>
        </div>
    )
}

const SiderContainer = (props) => {

    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex'
        }}>
            {props.children}
        </div>
    )
}

const Sider = (props, { bgColor = '#AFD3E2' }) => {

    return (
        <div style={{
            flex: 'none',
            backgroundColor: bgColor,
            ...props.style
            // padding: '1em 0'
        }} >
            {props.children}
        </div>
    )
}


const SiderNavBar = (props,) => {

    const navigate = useNavigate();

    const ClickNav = (url) => {
        navigate(url);
    }

    return (
        <div
            style={{
                minWidth: '10em',
                padding: '0.2em 0.5em 0.2em 0.5em',
                borderBottom: '1px solid',
                cursor: 'pointer',
                fontSize: '1.2em',
                fontWeight: 700,
                // backgroundColor: '#00000022'
            }}
            onClick={() => ClickNav(props.url)}
        >
            {props.title}
        </div>
    )
}

const Context = (props) => {

    return (
        <div style={{
            flex: 'auto',
            backgroundColor: '#fcfbf7'
        }} >
            {props.children}
        </div>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
-ms-flex-direction: column;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
flex-wrap: wrap;
`

const ContainerForm = styled.div`
display: flex;
flex-direction: column;
gap: inherit;
}
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 600;
}
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
`

const FlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
`

const Em20 = styled.div`
width: 20em;
`


export {
    Container1200,
    Containerfull,
    HeaderMidImg,
    SiderContainer,
    Sider,
    Context,
    SiderNavBar,
    MainContainer,
    ContainerForm,
    Title,
    SubTitle,
    PScontext,
    FlexBox,
    ColumnFlexBox,
    Em10,
    Em20,
}